import React from 'react';
import contensis from 'Common/api/contensis';
import cmsParser from 'Common/util/cmsParser';
import setCacheHeaders from 'Common/func/setCacheHeaders';

import Metadata from 'Components/Metadata';
import MainLayout from 'Layout/Main';
import Template, { datamap, PageData } from 'Templates/Facilities/Facility';

import type { NextPageWithLayout, GetServerSideProps } from 'next';

const Facility: NextPageWithLayout<PageData> = ({ entry, ancestors }) => {
    return (
        <>
            <Metadata {...cmsParser.metadata(entry)} />
            <Template {...datamap({ entry, ancestors })} />
        </>
    );
};

Facility.getLayout = (page, props) => {
    return <MainLayout {...props}>{page}</MainLayout>;
};

export const getServerSideProps: GetServerSideProps<any> = async ({ params, preview, res }) => {
    const { fetch, surrogateKeys } = contensis({ preview, fetchSurrogateKeys: true });

    const { facility } = params as { facility: string };

    const { data, error } = await fetch(async client => {
        const resPage = await client.nodes.get({
            path: `/facilities/${facility}`,
            entryLinkDepth: 2,
            entryFields: [
                'pageMetadata',
                'customTitle',
                'title',
                'heroBannerImageDefault',
                'virtualTourHeading',
                'virtualTourLink',
                'url',
                'heading',
                'description',
                'quote',
                'galleryHeading',
                'galleryCarousel',
                'link',
                'videoTitle',
                'thumbnail',
                'tableHeadingsVideoTranscript',
                'tableRowVideoTranscript',
                'equipmentHeading',
                'equipmentList',
                'coursesHeading',
                'coursesList',
                'degreeType',
                'name',
                'researchProjectsHeading',
                'researchProject',
                'buttons',
                'entryTitle',
                'hireHeading',
                'hireDescription',
                'availability',
                'contact',
                'email'
            ]
        });

        if (!resPage.entry) {
            return { error: true };
        }

        const ancestors = await client.nodes.getAncestors({
            id: resPage.id,
            entryFields: ['title']
        });

        return {
            entry: resPage.entry,
            ancestors
        };
    });

    if (error) {
        return { notFound: true };
    } else {
        setCacheHeaders(res, surrogateKeys);

        return { props: data };
    }
};

export default Facility;
